import React, { useEffect, useState } from 'react';
import Footer from '../Components/footer';
import smallecho from '../Images/C-ECHO/1.1.jpg';
import x1 from '../Images/C-ECHO/1.png';
import x2 from '../Images/C-ECHO/2.png';
import x3 from '../Images/C-ECHO/3.png';
import x4 from '../Images/C-ECHO/4.png';
import x5 from '../Images/C-ECHO/5.png';
import x6 from '../Images/C-ECHO/6.png';
import xBg from '../Images/Nimar/IMG-20171214-WA0141.jpg'
import y1 from '../Images/C-ECHO/147453560511296db548abeb55972074d3eb5115a3.jpg';
import y2 from '../Images/C-ECHO/RSI_7252-1.jpg';
import { Link, useNavigate } from "react-router-dom";
import Logo from "../Images/Home/boat.png";
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";

export default function Cechoii(props) {

    const [User, SetUser] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        onAuthStateChanged(props.auth, (user) => {
            if (user) {
                // User is signed in, see docs for a list of available properties
                // https://firebase.google.com/docs/reference/js/firebase.User
                SetUser(user);
                const uid = user.uid;
                // ...
                console.log("uid", uid)
            } else {
                // User is signed out
                // ...
                console.log("user is logged out")
            }
        });
    }, [])

    function signout() {
        signOut(props.auth).then(() => {
            window.location.reload(false);
            // Sign-out successful.
        }).catch((error) => {
            // An error happened.
        });
    }

    return (
        <div>
            <section>
            <nav className="navbar navbar-expand-lg navbar-dark nav-bg fixed-top">
                <div className="container-fluid">
                    <Link to="/" className="navbar-brand"><img src={Logo} alt="Logo" width="30" height="30" /></Link>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse"
                        data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                        aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0 navbar-nav-scroll">
                            <li className="nav-item">
                                <Link to="/" className="nav-link" aria-current="page">Home</Link>
                            </li>
                            <li className="nav-item dropdown">
                                <a className="nav-link dropdown-toggle active" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    Boats
                                </a>
                                <ul className="dropdown-menu">
                                    <li><Link to="/cechoii" className="dropdown-item">C-ECHO II</Link></li>
                                    <li><Link to="/nimar" className="dropdown-item">Nimar</Link></li>
                                </ul>
                            </li>
                            <li className="nav-item">
                                <Link to="/routes" className="nav-link">Routes</Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/news" className="nav-link">News</Link>
                                </li>
                            {User !== '' ? <li className="nav-item">
                                <Link to="/contact" className="nav-link ">Book a boat</Link>
                            </li> : null}
                        </ul>
                        <ul className="navbar-nav navbar-nav-scroll">
                            {User !== '' ? <li className="nav-item">
                                <Link to="/bookings" className="nav-link">Bookings</Link>
                            </li> : null}
                            <li className="nav-item">
                                {User === '' ? <Link to="/login" className="nav-link">Login</Link> : null}
                            </li>
                            <li className="nav-item">
                                {User === '' ? <Link to="/signup" className="nav-link">Register</Link> : null}
                            </li>
                            <li>
                                {User !== '' ? <Link to="/" className="nav-link" onClick={signout}>Logout</Link> : null}
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
                <div className="coverBig"></div>
                <div className="titleFleet">
                    <h2> The C-Echo II</h2>
                </div>
            </section>

            <section style={{ paddingTop: '20px' }}>
                <article className="d-flex flex-column flex-lg-row justify-content-lg-around justify-content-center align-items-center pb-5">
                    <div className="p-3 text-black text-center">
                        <p className="p-2">
                            A 36 m long wooden vessel completely renewed in 2012.10 double cabins downstairs and 2 double cabins & 1 Suite upstairs – all are Air-conditioned and equipped with mini bar, TV and ensuite bathroom/shower accommodate the guests.
                            Fresh towels are supplied for cabin use. You are advised to please bring your own bath towel for outdoor use.
                        </p>
                        <p className="p-2">
                            The wide air-conditioned salon with a separate dining area and TV/VDO/Stereo system allows guests on board to hang out in style and comfort. The various meals are served three times a day in buffet style.
                            Coffee, Tea and drinking water are of course included in the tour price.
                        </p>
                        <p className="p-2">
                            Two large sun decks invite guests to relax and take a sun bath. The dive deck and the dive platform are designed for maximum comfort and functionality. The three compressors are installed below deck to minimize noise impact. The divers will find 12 l aluminium tanks with DIN and INT valves. Multilingual dive guides will accompany the divers on board and under water.
                        </p>
                    </div>
                    <div style={{ backgroundImage: `url(${smallecho})` }} className="echo m-3"></div>
                </article>
            </section>
            <section className="text-white" style={{ backgroundImage: `url(${xBg})`, backgroundSize: "cover" }}>
                <article className="d-flex flex-column flex-lg-row align-items-center pb-5 px-5 py-5">
                    <div className="row row-cols-1 row-cols-md-3 g-4" style={{ color: "black" }}>
                        <div className="col">
                            <div className="card h-100" style={{ borderRadius: "20px" }}>
                                <img src={x1} className="card-img-top" alt="DOUBLE CABINS" style={{ borderRadius: "20px" }} />
                                <div className="card-body">
                                    <h5 className="card-title">DOUBLE CABINS</h5>
                                    <p className="card-text">The boat has 8 double cabins, equipped with air conditioning, minibar and bathroom with shower. Modern and spacious rooms designed for the comfort of each of our clients.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="card h-100" style={{ borderRadius: "20px" }}>
                                <img src={x2} className="card-img-top" alt="DIVING AREA" style={{ borderRadius: "20px" }} />
                                <div className="card-body">
                                    <h5 className="card-title">DIVING AREA</h5>
                                    <p className="card-text">The diving area stands out for its comfort and spaciousness, with charging stations for lights and cameras, common toilets, showers and fresh water containers and an exclusive space for each client.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="card h-100" style={{ borderRadius: "20px" }}>
                                <img src={x3} className="card-img-top" alt="COMMON STAYS area" style={{ borderRadius: "20px" }} />
                                <div className="card-body">
                                    <h5 className="card-title">COMMON STAYS</h5>
                                    <p className="card-text">Most areas of the ship are common rooms, such as lounges, terrace, solariums, restaurant and diving area. Modern design, minimalist and clean, designed for the comfort of the group.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="card h-100" style={{ borderRadius: "20px" }}>
                                <img src={x4} className="card-img-top" alt="RESTORATION area" style={{ borderRadius: "20px" }} />
                                <div className="card-body">
                                    <h5 className="card-title">RESTORATION</h5>
                                    <p className="card-text">The restaurant service is served in our restaurant lounge. A spacious stay, spread over the main restaurant where breakfast, lunch and dinner are served. High-quality international food.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="card h-100" style={{ borderRadius: "20px" }}>
                                <img src={x5} className="card-img-top" alt="SOLARIUMS" style={{ borderRadius: "20px" }} />
                                <div className="card-body">
                                    <h5 className="card-title">SOLARIUMS</h5>
                                    <p className="card-text">Two large solariums, one at the bow of the boat and another at the top are the area for sun-lovers and outdoor sailing. Areas designed for relaxation and recreation.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="card h-100" style={{ borderRadius: "20px" }}>
                                <img src={x6} className="card-img-top" alt="Master Cabins" style={{ borderRadius: "20px" }} />
                                <div className="card-body">
                                    <h5 className="card-title">Master Cabins</h5>
                                    <p className="card-text">For all Families, the boat has Master cabins with King size beds 4 family rooms with one big bed and one small bed beside (can be used as a double or triple room) If you want to reserve one of the cabins, tell us when to make your reservation.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </article>
            </section>
            <section>
                <div className="container px-5 py-5">
                    <div className="row">
                        <div className="col-md-8">
                            <h1 style={{ marginBottom: "25px" }} className='titleHome'>C-Echo II specs</h1>
                            <p><strong>Length</strong>: 36 m</p>
                            <p><strong>Width</strong>: 8 m</p>
                            <p><strong>Engines</strong>: 2 x 840 HP</p>
                            <p><strong>Generators</strong>: 2 Perkins 60kw, 2 Perkins 100kw</p>
                            <p><strong>Electricity</strong>: 220 V / 24 V</p>
                            <p><strong>Water</strong>: 20 tons + fresh water making machine</p>
                            <p><strong>Diesel</strong>: 20 tonsNavigation: Radar, GPS, Sounder, Leverb</p>
                            <p><strong>Communication</strong>: CB RadioSafety: 2 Life Rafts.20 person for one, 2 dinghies with outboard engine (25 HP) + (40HP) yamaha</p>
                            <p><strong>First Aid</strong>: Oxygen and first aid box</p>
                            <p><strong>Scuba Equipment:</strong> 30 tank , 12 L aluminum</p>
                            <p><strong>Compressors</strong>: 2 x BAUER Mariner (below deck) + system Nitrox</p>
                            <p><strong>Amenities</strong>: Air-con double cabins (no bunk beds) with minibar, TV and ensuite shower/head Big air-conditioned salon with Video/TV and Audio Big dive deck with recharging + DVD</p>
                            <p> </p>
                        </div>
                        <div className="col-md-4">
                            <div className="row">
                                <div className="col-md-12">
                                    <img src={y1} alt="c-echo ii deck" className="img-fluid mb-3" />
                                </div>
                                <div className="col-md-12">
                                    <img src={y2} alt="C-ECHO II" className="img-fluid" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    );
}